import { render, staticRenderFns } from "./IconChevronUpOutline.vue?vue&type=template&id=5883a323"
import script from "./IconChevronUpOutline.vue?vue&type=script&lang=js"
export * from "./IconChevronUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports